import React, { useState } from "react";
import { Form, Input, Modal } from "antd";
import { useDispatch } from "react-redux";
import { createOrganization } from "../redux/actions/organizationAction";

export default function CreateOrganizationModal({ open, onClose }) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const handleClose = () => {
    form.resetFields();
    onClose?.();
  };

  const handleSubmit = async (values) => {
    setSubmitting(true);
    try {
      const result = await dispatch(createOrganization(values.name.trim()));
      if (result?.accessToken) {
        handleClose();
        window.location.assign("/app");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title="Create organization"
      open={open}
      onCancel={handleClose}
      okText="Create"
      confirmLoading={submitting}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="name"
          label="Organization name"
          rules={[
            { required: true, message: "Please enter an organization name" },
            { whitespace: true, message: "Please enter an organization name" },
          ]}
        >
          <Input placeholder="Acme Inc." autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  );
}
